import { useState, useEffect } from 'react';
import styles from './list.module.css';
import axios from 'axios';
import { authData } from "../../components/getAuth";
import Select from "react-select";
import { toast } from 'react-toastify';

const AssignPopupNew = ({ selectedDriverList, setSelectedDriverList, setAssignModalShow }) => {
    const auth = authData();
    const API_TOKEN = auth?.api_token;
    const [driverList, setDriverList] = useState([]);

    useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL + 'v1/p-driver-dd-list', {
            headers: {
                Authorization: `Bearer ${API_TOKEN}`,
            }
        }).then(response => {
            if (response.data.status === 'SUCCESS') {
                setDriverList(response.data.data);
            }
        });
    }, [API_TOKEN]);

    const onSubmitLocal = () => {
        if (selectedDriverList.length === 0) {
            toast.error('Please select item(s)', {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                theme: "light",
            });

            return false;
        }

        setAssignModalShow(false);
    }


    return (<>
        <div className={`${styles.FullDiv}`}>
            <div className={`${styles.FormGroupFull}`}>
                <label className={`${styles.FormLabel}`}>Select Driver*</label>
                <Select
                    options={driverList}
                    isMulti
                    value={selectedDriverList}
                    onChange={(e) => {
                        setSelectedDriverList(e);
                    }}
                />
            </div>
            <div className={`${styles.FormButtonArea}`}>
                <input className={`${styles.SubmitBU}`} value="Select" type="button" onClick={(e) => onSubmitLocal()} />
            </div>
        </div>
    </>)
}

export default AssignPopupNew;